import { IApiServiceContext, ApiServiceContextState } from '../context/ApiServiceContext';
import { useContext } from 'react';
import {ISettingsContext, SettingsContextState} from "../context/SettingsContext";
import ThemeContext, {IThemeContext, IThemeContextState} from "../context/ThemeContext";
import TestRoomContext, {ITestRoomContext, TestRoomContextState} from "../context/TestRoomContext";

export const useTestRoom = () => useContext<TestRoomContextState>(ITestRoomContext)